var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoTextBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h512v512h-512z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.478 512a258.839 258.839 0 0 1 -51.689-5.2 255.327 255.327 0 0 1 -91.71-38.52 256.812 256.812 0 0 1 -92.924-112.634 254.366 254.366 0 0 1 -14.944-48.054 258.024 258.024 0 0 1 0-103.186 254.343 254.343 0 0 1 38.589-91.538 256.785 256.785 0 0 1 442.369 29.1 254.015 254.015 0 0 1 25.831 91.771h-114.486a142.318 142.318 0 0 0 -30.744-67.639 143.483 143.483 0 0 0 -37.319-31.987 142.877 142.877 0 1 0 20.749 230.66 143.4 143.4 0 0 0 31.272-38.531 141.807 141.807 0 0 0 16.333-47.982h114.195a254.594 254.594 0 0 1 -50.447 131.508 257 257 0 0 1 -110.153 84.126 255.634 255.634 0 0 1 -45.9 13.433 259.068 259.068 0 0 1 -49.022 4.673z",
    fill: "#4962c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.142 97.036c-17.012-58.884-57.86-89.159-106.715-89.159s-98.605 36.762-109.172 89.159z",
    fill: "#dbc772",
    transform: "translate(147.607 135.055)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoTextBlue);
export default __webpack_public_path__ + "static/media/logo-no-text-blue.40effad42afbbbdc8c3ba477d81cd6b6.svg";
export { ForwardRef as ReactComponent };